import { atom } from "recoil";

export const taskManagerStore = atom({
	key: "taskManagerStore",
	default: {
		data: [],
		loaded: true,
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
	},
});
